import React from 'react';
import { Card, Flex, Typography, theme } from 'antd';
import { ChargeBeePlanId } from '@prerender/billing-shared';
import {
  SEARCH_PERFORMANCE_PLAN_COPY,
  SearchPerformanceUpgradeRow,
  useSearchPerformancePlanLabel,
} from '~features/SearchPerformance';

import { SEARCH_PERFORMANCE_CARD_DESCRIPTION, SEARCH_PERFORMANCE_CARD_TITLE } from './SearchPerformanceCardCopy';

// Names the Search Performance origin (PRE-3271 #6) so the shared
// `UpgradeClicked` event tells an SP upsell apart from other Integrations CTAs.
const CTA_LOCATION = 'Search Performance - Locked Card';

function SearchPerformanceLockedCard() {
  const { token } = theme.useToken();
  const planName = useSearchPerformancePlanLabel();

  return (
    <Card
      title={SEARCH_PERFORMANCE_CARD_TITLE}
      styles={{ body: { paddingTop: token.padding, paddingBottom: token.padding } }}
    >
      <Flex vertical gap={token.marginXXS}>
        <Typography.Text>{SEARCH_PERFORMANCE_CARD_DESCRIPTION}</Typography.Text>
        <SearchPerformanceUpgradeRow
          message={SEARCH_PERFORMANCE_PLAN_COPY.notIncluded(planName)}
          ctaLabel={SEARCH_PERFORMANCE_PLAN_COPY.upgradeToPro}
          targetPlanId={ChargeBeePlanId.Pro}
          ctaLocation={CTA_LOCATION}
        />
      </Flex>
    </Card>
  );
}

export default SearchPerformanceLockedCard;
